import React, { Component } from "react";
import {
  NormalInput,
  NormalSelect,
  NormalButton,
  NormalDate,
  NormalModal,
  NormalCheckbox,
  NormalTextarea,
  NormalTimePicker,
} from "component/common";
import { CreateAppointment, updateForm } from "redux/actions/appointment";
import {
  getCustomer,
  getCommonApi,
  commonCreateApi,
  commonDeleteApi,
  commonPatchApi,
} from "redux/actions/common";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { dateFormat } from "service/helperFunctions";
import { history } from "helpers";
import SimpleReactValidator from "simple-react-validator";
import closeIcon from "assets/images/close.png";
import _ from "lodash";
import { AddWalkinCustomer } from "./NewWalkinCustomer";
import { AppointmentLog } from "../CommonModal/Appointmentlog";
import logicon from "assets/images/logicon.png";
import { withTranslation } from "react-i18next";
import { Toast } from "service/toast";
import { Label } from "reactstrap/lib";
import { IoSearchCircle } from "react-icons/io5";

export class AppointmentFormClass extends Component {
  state = {
    active: false,
    appt_fr_time: "",
    appt_to_time: "",
    currentValue: "-1",
    formFields: {
      customerName: "",
      emp_id: "",
      appointmentDate: new Date(),
      bookingStatus: "",
      Source_Codeid: "",
      ItemSite_Codeid: "",
      new_remark: "",
      Appt_typeid: "",
      // emp_noid : 4,
      Room_Codeid: "",
      sec_status: "",
      bookedby: "",
      editedby: "",
      walkin: false,
      remark_setting: false,
      edit_remark: "",
      cart_create: false,
      cust_StoreCard: false,
      cust_refer: "",

      maxclasssize: 0,
      isOpenParticipants: false,
      participantName: "",
      editParticipantId: "",
      editParticipantStatus: "Booked",
      editParticipantRemarks: "",
      editParticipantStatusList: [
        { value: "Booked", label: "Booked" },
        { value: "Cancelled", label: "Cancelled" },
        { value: "Arrived", label: "Arrived" },
        { value: "Done", label: "Done" },
      ],

      chkMaxClass: false,
    },
    multipleCustomerForm: {
      noOfCustomer: 1,
      treatment: "",
      room: "",
    },
    bookingList: [],
    optionsUserList: [],
    isOpenModal: false,
    multipleCustomr: 1,
    customerElement: [],
    siteList: [],
    sourceList: [],
    channelList: [],
    staffList: [],
    secStatusList: [],
    roomList: [],
    customerOption: [],
    search: "",
    customerId: 0,
    appointmentId: null,
    isWalkin: false,
    isAppointmentLogModal: false,
    visible: false,
    InitStatus: "",
    participantsData: [],
    participantVisible: false,
    selectedParticipantsFromAppointments: [],
    editParticipantPopUp: false,
    checkinTime: "",
    checkoutTime: "",
    checkedOut: false,
    checkinId: null,
  };

  componentWillMount = () => {
    this.validator = new SimpleReactValidator({
      element: (message) => (
        <span className="error-message text-danger validNo fs14">
          {message}
        </span>
      ),
      autoForceUpdate: this,
      validators: {
        date: {
          // name the rule
          message: "The :attribute must be grater than today.",
          rule: (val, params, validator) => {
            let date1 = new Date(dateFormat(new Date()));
            let date2 = new Date(dateFormat(val));

            return date1.getTime() <= date2.getTime();
          },
          //   messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true, // optional
        },
      },
    });
  };

  componentDidMount = async () => {
    //unwanted code commented in api triggred but not called
    // this.props.getCustomer("all/").then(() => {});
    this.props.getCommonApi("bookingstatus/").then((res) => {
      let { status, data, sec_data } = res;

      if (status === 200) {
        this.setState({ bookingList: data, secStatusList: sec_data });
      }
    });

    this.props.getCommonApi("fmspwuserlist/").then((res) => {
      let { status, data } = res;
      if (status === 200) {
        let { formFields } = this.state;
        const options = data.map((d) => ({
          value: d.pw_userlogin,
          label: d.pw_userlogin,
        }));

        let usernameObject = data?.find(
          (list) => list.id === this.props.tokenDetail?.login_id
        );
        formFields["bookedby"] = usernameObject?.pw_userlogin;

        console.log(usernameObject, "username");
        this.setState({ optionsUserList: options, formFields });
      }
    });

    // this.handleCustomerElement()
    this.props.onRef(this);

    let { staffList, formFields } = this.state;

    let { basicApptDetail } = this.props;
    console.log(basicApptDetail.date, "basicDate");
    formFields["appointmentDate"] = basicApptDetail.date
      ? basicApptDetail.date
      : new Date();
    console.log(formFields.appointmentDate, "formFieldsDate");
    let booking_status = "Booking";
    formFields["bookingStatus"] = booking_status;
    formFields["ItemSite_Codeid"] = basicApptDetail.branchId;
    this.setState({ formFields });
    await this.props.updateForm("appointmentCustomerDetail", formFields);

    this.getListData();
    // Added by Santhosh (this.props.siteId)
    const siteId = this.props.siteId || this.props.tokenDetail.logined_siteid;
    const date = isNaN(new Date(basicApptDetail.date))
      ? dateFormat(new Date())
      : dateFormat(new Date(basicApptDetail.date));
    this.props
      .getCommonApi(`appointment/Staffs/?Outlet=${siteId}&date=${date}`)
      .then((key) => {
        let { status, data } = key;
        if (status === 200) {
          for (let value of data) {
            staffList.push({ value: value.id, label: value.emp_name });
          }
          this.setState({ staffList });
        }
      });

    if (basicApptDetail.appt_id) {
      this.setState({ appointmentId: basicApptDetail.appt_id });
      this.handleAppointmentDetailRender(basicApptDetail.appt_id, false);
    } else if (
      this.props.PasteAppointmentId &&
      this.props.PasteAppointmentId > 0
    ) {
      this.handleAppointmentDetailRender(this.props.PasteAppointmentId, true);
    }
  };

  getCheckinTime = async (data) => {
    console.log(data, "DAta");
    console.log(this.props.basicApptDetail, "basic");
    const fromDate = `${data?.appointmentDate}T00:00:00`;
    this.props
      .getCommonApi(
        `customercheckins/?cust_name=${data?.custName}&date_from=${fromDate}`
      )
      .then((res) => {
        const data =
          res?.results?.find(
            (item) =>
              item?.appt_id === this.props.basicApptDetail?.appt_id &&
              item?.Appt_date
          ) || res?.results?.find((item) => !("appt_id" in item));
        const getCheckinTime = data?.Appt_date;
        const getCheckoutTime = data?.checkedOutTime;
        if (getCheckinTime) {
          const extractCheckinTime = new Date(getCheckinTime);
          this.setState({
            checkinTime: extractCheckinTime,
            checkinId: res?.results[0]?.CustomerCheckInId,
          });
        }
        if (getCheckoutTime) {
          const extractCheckoutTime = new Date(getCheckoutTime);
          this.setState({
            checkoutTime: extractCheckoutTime,
            checkinId: res?.results[0]?.CustomerCheckInId,
          });
        }
      });
  };

  formatDateToLocalISO = (date) => {
    if (date) {
      const pad = (num) => String(num).padStart(2, "0");

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }
  };

  postCheckinTime = async () => {
    let { checkinTime, checkoutTime, checkedOut, checkinId } = this.state;
    let validCheckinTime = checkinTime !== "" ? checkinTime : new Date();
    let isCheckinTime = this.formatDateToLocalISO(validCheckinTime);
    let isCheckoutTime = this.formatDateToLocalISO(checkoutTime);
    let { appointmentCustomerDetail, basicApptDetail } = this.props;
    let payload = {
      cust_no: appointmentCustomerDetail?.customerName,
      Appt_date: isCheckinTime,
      Cust_name: appointmentCustomerDetail?.custName,
      Remarks: appointmentCustomerDetail?.cust_remark,
      checkedOut: checkedOut,
      appt_id: basicApptDetail?.appt_id,
    };
    if (checkedOut) {
      payload.checkedOutTime = isCheckoutTime;
    }
    if (checkinId) {
      this.props
        .commonPatchApi(`customercheckins/${checkinId}/`, payload)
        .then((res) => {
          console.log(res, "Response");
          this.getCheckinTime(appointmentCustomerDetail);
        });
    } else {
      this.props.commonCreateApi(`customercheckins/`, payload).then((res) => {
        console.log(res, "Response");
        this.getCheckinTime(appointmentCustomerDetail);
      });
    }
    console.log(payload, "payload");
  };

  handleAppointmentDetailRender = (appt_id, copy) => {
    let { formFields, InitStatus } = this.state;
    // Added by Santhosh (this.props.siteId)
    this.props
      .getCommonApi(
        `appointmentedit/${appt_id}/?site_select=${this.props.siteId}`
      )
      .then((key) => {
        let { status, data } = key;
        if (status === 200) {
          if (data.appointment) {
            formFields["custName"] = data.appointment.cust_name;
            if (!copy) {
              formFields["appointmentDate"] = data.appointment.appt_date;
              formFields["bookingStatus"] = data.appointment.appt_status;
              InitStatus = data.appointment.appt_status;
            }
            if (copy) {
              let booking_status = "Booking";
              formFields["bookingStatus"] = booking_status;
            }
            // if (this.props.tokenDetail?.allowtochangecustomerinappointment) {
            //   formFields["new_remark"] = data.appointment.cust_name;
            // } else {
            formFields["new_remark"] = data.appointment.ori_remark;
            // }

            formFields["edit_remark"] = data.appointment.edit_remark;
            formFields["customerName"] = data.appointment.cust_id;
            formFields["Source_Codeid"] = data.appointment.source_id;
            formFields["Room_Codeid"] = data.appointment.Room_Codeid;
            formFields["sec_status"] = data.appointment.sec_status;
            formFields["Appt_typeid"] = data.appointment.channel_id;
            formFields["remark_setting"] = data.appointment.remark_setting;
            formFields["custPhone"] = data.appointment.cust_phone1;
            formFields["cust_remark"] = data.appointment.permanent_remark;
            formFields["cust_StoreCard"] = data.appointment.cust_StoreCard;
            formFields["bookedby"] = data.appointment.bookedby;
            formFields["editedby"] = data.appointment.editedby;
            formFields["maxclasssize"] = data.appointment.maxclasssize;

            formFields["cust_refer"] = data.appointment.cust_refer;
            this.setState({ formFields, InitStatus });
            this.setState({ customerId: data.appointment.cust_id });
            this.props.selectedCustomer(data.appointment.cust_id);
            this.props.updateForm("appointmentCustomerDetail", formFields);
            this.getCheckinTime(formFields);
          }
        }
      });
  };

  componentWillUnmount() {
    this.props.onRef(null);
  }

  getListData = () => {
    let { sourceList, siteList, channelList, roomList } = this.state;

    this.props.getCommonApi(`source/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        for (let value of data) {
          sourceList.push({ value: value.id, label: value.source_desc });
        }
        this.setState({ sourceList });
      }
    });
    this.props.getCommonApi(`treatment/Outlet/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        for (let value of data) {
          siteList.push({ value: value.id, label: value.itemsite_code });
        }
        this.setState({ siteList });
      }
    });
    this.props.getCommonApi(`appttype/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        for (let value of data) {
          channelList.push({ value: value.id, label: value.appt_type_desc });
        }
        this.setState({ channelList });
      }
    });
    this.props
      .getCommonApi(`room/?outlet=${this.state.formFields.ItemSite_Codeid}`)
      .then((key) => {
        let { status, data } = key;
        if (status === 200) {
          for (let value of data) {
            roomList.push({ value: value.id, label: value.displayname });
          }
          this.setState({ roomList });
        }
      });
  };

  selectTime = async (key, type) => {
    let { formFields } = this.state;
    if (type === "appt_fr_time") {
      formFields["appt_fr_time"] = key;
      await this.setState({
        formFields,
        appt_fr_time: key,
      });
    } else {
      formFields["appt_to_time"] = key;
      await this.setState({
        formFields,
        appt_to_time: key,
      });
    }

    await this.props.updateForm("appointmentCustomerDetail", formFields);
  };

  handleClick = () => {
    if (!this.state.visible) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    if (this.state.visible) {
      let { basicApptDetail } = this.props;
      this.search(basicApptDetail);
    }
    this.setState((prevState) => ({
      visible: !prevState.visible,
    }));
  };

  handleOutsideClick = (e) => {
    if (this.node != null) {
      if (this.node.contains(e.target)) {
        return;
      }
    }
    this.handleClick();
  };

  onFocus = () => {
    this.validator.showMessages();
  };

  handleChange = async ({ target: { value, name } }) => {
    let { formFields } = this.state;
    formFields[name] = value;
    await this.setState({
      formFields,
    });
    this.props.updateForm("customerDetail", formFields);
    await this.props.updateForm("appointmentCustomerDetail", formFields);
    if (name === "ItemSite_Codeid") {
      let { staffList } = this.state;
      // Added by Santhosh (this.props.siteId)
      this.props
        .getCommonApi(`appointment/Staffs/?Outlet=${this.props.siteId}`)
        .then((key) => {
          let { status, data } = key;
          if (status === 200) {
            for (let value of data) {
              staffList.push({ value: value.id, label: value.emp_name });
            }
            this.setState({ staffList });
          }
        });
    }

    if (name === "isWalkin") {
      // let { formFields } = this.state;
      // formFields["customerName"] = "";
      // formFields["custName"] = "";
      // formFields["cust_refer"] = "";
      // this.setState({ formFields });
      this.setState((prevState) => ({
        isWalkin: !prevState.isWalkin,
      }));
    }
    if (name == "bookingStatus" && String(value).toUpperCase() == "CANCELLED") {
      let { formFields } = this.state;
      formFields["sec_status"] = "Rescheduled";
      this.setState({
        formFields,
      });
    }

    if (name == "chkMaxClass" && value == true) {
      this.handleSearchForDefaultCustomer("class"); //Yoonus
      let { formFields } = this.state;
      formFields["maxclasssize"] = 1; //Yoonus
      this.setState({
        formFields,
      });
    }
    if (name == "maxclasssize") {
      if (value.length >= 4) {
        let { formFields } = this.state;
        formFields["maxclasssize"] = value.slice(0, -1);
        this.setState({
          formFields,
        });
      }
    }

    if (name == "chkMaxClass" && value == false) {
      //this.handleSearchForDefaultCustomer("");

      let { formFields } = this.state;
      formFields["customerName"] = "";
      formFields["custName"] = "";
      formFields["maxclasssize"] = 0;
      this.setState({
        formFields,
      });
    }
  };

  handleMultiple = async ({ target: { value, name } }) => {
    let { multipleCustomerForm } = this.state;
    if (name === "noOfCustomer") {
      multipleCustomerForm[name] = Number(value);
    }
    if (name === "sameForAllTreatment" || name === "differentForAllTreatment") {
      if (name === "differentForAllTreatment") {
        multipleCustomerForm["treatment"] = 2;
      } else {
        multipleCustomerForm["treatment"] = 1;
      }
    } else {
      if (name === "differentForAllRoom") {
        multipleCustomerForm["room"] = 2;
      } else {
        multipleCustomerForm["room"] = 1;
      }
    }

    await this.setState({
      multipleCustomerForm,
    });
    this.props.updateForm("multipleCustomerForm", multipleCustomerForm);
  };

  handleSubmit = () => {
    history.push(`/admin/newappointment/create/select-treatment`);
  };

  getTime = (data) => {
    let time = data.split(" ");
    let time1 = time[0].split(":");
    if (time[1] === "pm") {
      return (
        (Number(time1[0]) + 12 === 24 ? "00" : Number(time1[0]) + 12) +
        ":" +
        time1[1]
      );
    } else {
      return time1[0] < 9 ? "0" + time[0] : time1[0] + ":" + time1[1];
    }
  };

  handleDialog = () => {
    let { isOpenModal } = this.state;
    isOpenModal = !isOpenModal;
    this.setState({
      isOpenModal,
    });
  };

  handleMultipleCustomer = async () => {
    let { multipleCustomerForm } = this.props;
    await this.setState({
      multipleCustomr: multipleCustomerForm.noOfCustomer,
      customerElement: [],
    });

    this.handleCustomerElement(multipleCustomerForm.noOfCustomer);
  };

  handleSearch = async (event) => {
    //    event.persist();
    let { formFields } = this.state;
    formFields["custName"] = event.target.value;
    await this.setState({ formFields });
  };

  handleIconSearch = async () => {
    this.handleClick();
    let { basicApptDetail } = this.props;
    await this.setState({ visible: true });
    await this.search(basicApptDetail);
  };

  handleSearchForDefaultCustomer(xDefaultCustomerName) {
    let { formFields } = this.state;
    formFields["customerName"] = 1060; //1060 in avantetrain //15343 in staging
    formFields["custName"] = xDefaultCustomerName;
    this.setState({ formFields });
    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(async () => {
        let { basicApptDetail } = this.props;
        this.search(basicApptDetail);
      }, 500);
    }
    this.debouncedFn();
  }

  search = (basicApptDetail) => {
    let { formFields } = this.state;
    let { branchId } = basicApptDetail;
    this.props
      .getCommonApi(
        `custappt/?Outlet=${branchId ? branchId : ""}&search=${
          formFields.custName
        }`
      )
      .then((key) => {
        let { status, data } = key;
        if (status === 200) {
          this.setState({ customerOption: data });
        }
      });
  };

  handleSelectCustomer = async (data) => {
    let { formFields } = this.state;

    let { id, cust_name, cust_phone2, cust_remark, cust_refer } = data;

    formFields["customerName"] = id;
    formFields["custName"] = cust_name;
    formFields["custPhone"] = cust_phone2; //previously cust_phone1 yoonus
    formFields["cust_remark"] = cust_remark;
    formFields["cust_refer"] = cust_refer;
    await this.props.updateForm("appointmentCustomerDetail", formFields);
    await this.setState({ formFields, customerOption: [] });
    await this.setState({ customerId: id });
    this.props.selectedCustomer(id);
    this.handleClick();
  };

  handleWalkInCustomer = async (data) => {
    let { formFields } = this.state;
    let { id, cust_name, cust_phone2, cust_refer } = data;
    formFields["customerName"] = id;
    formFields["custName"] = cust_name;
    formFields["custPhone"] = cust_phone2;
    formFields["cust_remark"] = "";
    formFields["cust_refer"] = cust_refer;
    await this.props.updateForm("appointmentCustomerDetail", formFields);
    this.setState({ formFields });
    this.setState({ customerId: id });
    this.props.selectedCustomer(id);
    await this.setState((prevState) => ({
      isWalkin: !prevState.isWalkin,
    }));
  };

  handleLogClick = () => {
    this.setState((prevState) => ({
      isAppointmentLogModal: !prevState.isAppointmentLogModal,
    }));
  };

  handleParticipantsButtonClick = () => {
    this.setState({ isOpenParticipants: true });
    this.listParticipants();
  };
  handleParticipantsDialog = async () => {
    let { isOpenParticipants } = this.state;
    isOpenParticipants = false;
    await this.setState({
      isOpenParticipants,
    });
  };
  handleParticipantSearchFromTextBox = async (event) => {
    //event.persist();
    let { formFields, participantVisible } = this.state;
    formFields["participantName"] = event.target.value;
    participantVisible = true;
    await this.setState({ formFields, participantVisible });
    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(async () => {
        let { basicApptDetail } = this.props;
        this.handleParticipantSearch(basicApptDetail);
      }, 500);
    }
    this.debouncedFn();
  };
  handleParticipantClick = (key) => {
    /*if (!this.state.participantVisible) {
      document.addEventListener("click", this.handleParticipantOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleParticipantOutsideClick, false);
    }

    if (this.state.participantVisible) {
      let { basicApptDetail } = this.props;
      this.handleParticipantSearch(basicApptDetail);
    }
    this.setState(prevState => ({
      participantVisible: !prevState.visible,
    }));
  };

  handleParticipantOutsideClick = e => {
    if (this.node != null) {
      if (this.node.contains(e.target)) {
        return;
      }
    }
    this.handleParticipantClick();*/
  };
  handleParticipantSearch = () => {
    let { formFields } = this.state;
    this.setState({ participantsData: [] });
    this.props
      .getCommonApi(`custsearchclass/?search=${formFields.participantName}`)
      .then((key) => {
        let { status, data } = key;
        if (status === 200) {
          this.setState({ participantsData: data });
        }
      });
  };

  handleSelectParticipant = async (data) => {
    let { appointmentId, formFields, selectedParticipantsFromAppointments } =
      this.state;
    let passPostApiData = {
      appt_id: appointmentId,
      cust_id: data.id,
      date_booked: dateFormat(new Date(), "yyyy-mm-dd"),
      status: "Booked",
      remarks: "",
    };
    this.setState({ participantVisible: false });
    if (
      formFields.maxclasssize <= selectedParticipantsFromAppointments.length
    ) {
      Toast({
        type: "error",
        message: "Participant reached the defined limit",
      });
      return;
    }

    this.props.commonCreateApi(`participants/`, passPostApiData).then((key) => {
      Toast({
        type: "success",
        message: "Participant Added Successfully",
      });
      this.listParticipants();
    });
  };

  listParticipants = () => {
    let { appointmentId } = this.state;

    this.setState({ selectedParticipantsFromAppointments: [] });
    this.props
      .getCommonApi(`participants/?page=1&limit=12&appt_id=${appointmentId}`)
      .then((key) => {
        let { status, data } = key;
        if (status === 200) {
          this.setState({
            selectedParticipantsFromAppointments: data.dataList,
          });
        }
      });
  };

  deleteParticipantById = (id) => {
    this.props.commonDeleteApi(`participants/${id}`).then(() => {
      Toast({
        type: "success",
        message: "Participant Deleted Successfully",
      });
      this.listParticipants();
    });
  };
  editParticipantById = (item) => {
    let { formFields } = this.state;
    let { id, remarks, status } = item;
    formFields["editParticipantId"] = id;
    formFields["editParticipantRemarks"] = remarks;
    formFields["editParticipantStatus"] = status;
    this.setState({
      formFields,
      editParticipantPopUp: true,
    });
  };
  handleParticipantUpdate = () => {
    let { editParticipantStatus, editParticipantRemarks, editParticipantId } =
      this.state.formFields;
    let apiBody = {
      date_booked: dateFormat(new Date(), "yyyy-mm-mm"),
      status: editParticipantStatus,
      remarks: editParticipantRemarks,
    };
    // cust_noid : 235323
    this.props
      .commonPatchApi(`participants/${editParticipantId}/`, apiBody)
      .then(() => {
        Toast({
          type: "success",
          message: "Participant Edited Successfully",
        });
        this.listParticipants();
        this.setState({
          editParticipantPopUp: false,
          editParticipantRemarks: "",
        });
      });
  };

  getHoursFromDate = (date) => {
    let hour = date.getHours();
    let minute = date.getMinutes();
    let hours = hour > 9 ? hour : "0" + hour;
    let minutes = minute > 9 ? minute : "0" + minute;
    return hours + ":" + minutes;
  };
  handleTimePick = async (event) => {
    let value = event.target.value;

    let { checkinTime, checkoutTime, checkedOut } = this.state;
    checkinTime = value;
    if (value) {
      checkoutTime = value;
      checkedOut = false;
    }
    console.log(checkinTime, "checkinTime");
    await this.setState({
      checkinTime,
      checkoutTime,
      checkedOut,
    });
  };

  handleCheckoutTime = async (event) => {
    let value = event.target.value;

    let { checkoutTime, checkedOut } = this.state;
    checkoutTime = value;
    checkedOut = true;
    await this.setState({
      checkoutTime,
      checkedOut,
    });
  };

  render() {
    let {
      optionsUserList,
      bookingList,
      channelList,
      secStatusList,
      roomList,
      customerOption,
      sourceList,
      formFields,
      appointmentId,
      isWalkin,
      isAppointmentLogModal,
      visible,
      participantVisible,
      isOpenParticipants,
      participantsData,
      selectedParticipantsFromAppointments,
      checkinTime,
      checkoutTime,
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="form-group mb-4 pb-2 appointment-form">
          <div className="d-flex">
            <div className="d-flex justify-content-start col-md-11 col-12 h5 p-0">
              {appointmentId && appointmentId > 0
                ? t("Edit Appointment")
                : t("Create Appointment")}
            </div>
            {appointmentId && appointmentId > 0 ? (
              <div
                className="d-flex justify-content-end align-items-center bg-white cursor-pointer col-md-1 col-12"
                onClick={this.handleLogClick}
              >
                <img
                  src={logicon}
                  alt="AppointmentForm"
                  width="35px"
                  height="35px"
                />
              </div>
            ) : null}
          </div>
          <div className="row">
            <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 mb-3">
              <label className="text-left text-black common-label-text ">
                {t("Date")}{" "}
                <span className="error-message text-danger validNo fs-18">
                  *
                </span>
              </label>
              <div className="">
                <NormalDate
                  value={new Date(formFields.appointmentDate)}
                  name="appointmentDate"
                  type="date"
                  onChange={this.handleChange}
                  minDate={new Date()}
                  showDisabledMonthNavigation
                />
              </div>
              {this.validator.message(
                "appointmentDate",
                formFields.appointmentDate,
                "required|date"
              )}
            </div>
            <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 mb-3">
              <div>
                <label className="text-left text-black common-label-text ">
                  {t("Name")}{" "}
                  <span className="error-message text-danger validNo fs-18">
                    *
                  </span>
                </label>
              </div>
              <div className="input-group">
                {console.log(formFields, "formFields")}
                {appointmentId &&
                !this.props.tokenDetail?.allowtochangecustomerinappointment ? (
                  <NormalInput
                    placeholder="search"
                    value={formFields.custName}
                    name="customerName"
                    onChange={this.handleSearch}
                    disabled
                  />
                ) : (
                  <div className="d-flex">
                    <div className="col-11 pr-0 pl-0">
                      <NormalInput
                        placeholder="search"
                        value={formFields.custName}
                        name="customerName"
                        onChange={this.handleSearch}
                        disabled={formFields.chkMaxClass}
                      />
                    </div>
                    {formFields.chkMaxClass ? (
                      <></>
                    ) : (
                      <div
                        className="col-1 border-primary pl-0 cursor-pointer"
                        onClick={() => {
                          this.handleIconSearch();
                        }}
                      >
                        <IoSearchCircle color="#023f88" size={35} />
                      </div>
                    )}
                  </div>
                )}
              </div>
              {this.validator.message(
                "customerName",
                formFields.customerName,
                "required"
              )}
            </div>

            <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 mb-3">
              <label className="text-left text-black common-label-text ">
                {t("Booking Status")}{" "}
                <span className="error-message text-danger validNo fs-18">
                  *
                </span>
              </label>
              <div className="input-group">
                <NormalSelect
                  options={bookingList}
                  value={formFields.bookingStatus} //
                  name="bookingStatus"
                  onChange={this.handleChange}
                  className="customer-name status py-1"
                />
                {this.validator.message(
                  "Booking Status",
                  formFields.bookingStatus,
                  "required"
                )}
              </div>
            </div>

            <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 mb-3">
              <div>
                <label className="text-left text-black common-label-text ">
                  {t("Channel")}
                </label>
              </div>
              <div className="input-group">
                <NormalSelect
                  options={channelList}
                  value={formFields.Appt_typeid}
                  name="Appt_typeid"
                  onChange={this.handleChange}
                  className="customer-name py-1"
                />
              </div>
            </div>

            <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 mb-3">
              <label className="text-left text-black common-label-text ">
                {t("Remark")}
              </label>

              <div className="input-group">
                {formFields.remark_setting ? (
                  <NormalTextarea
                    // placeholder="Enter here"
                    // options={siteList}
                    value={formFields.new_remark}
                    name="new_remark"
                    onChange={this.handleChange}
                    disabled
                  />
                ) : (
                  <NormalTextarea
                    // placeholder="Enter here"
                    // options={siteList}
                    value={formFields.new_remark}
                    name="new_remark"
                    onChange={this.handleChange}
                  />
                )}
              </div>
              {/* {this.validator.message('Remark', formFields.new_remark, 'required')} */}
            </div>

            <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 mb-3">
              <div>
                <label className="text-left text-black common-label-text ">
                  {t("Source Name")}
                </label>
              </div>
              <div className="input-group">
                <NormalSelect
                  // placeholder="Enter here"
                  options={sourceList}
                  value={formFields.Source_Codeid}
                  name="Source_Codeid"
                  onChange={this.handleChange}
                  className="customer-name py-1"
                />
              </div>
              {/* {this.validator.message('Source name', formFields.Source_Codeid, 'required')} */}
            </div>
            <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 mb-3">
              <div>
                <label className="text-left text-black common-label-text ">
                  {t("Room")}
                </label>
              </div>
              <div className="input-group">
                <NormalSelect
                  // placeholder="Enter here"
                  options={roomList}
                  value={formFields.Room_Codeid}
                  name="Room_Codeid"
                  onChange={this.handleChange}
                  className="customer-name py-1"
                />
              </div>
              {/* {this.validator.message('Room', formFields.Room_Codeid, 'required')} */}
            </div>

            <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 mb-3">
              <label className="text-left text-black common-label-text ">
                {t("Secondary Status")}
              </label>
              <div className="input-group">
                <NormalSelect
                  options={secStatusList}
                  value={formFields.sec_status}
                  name="sec_status"
                  onChange={this.handleChange}
                  className="customer-name py-1"
                />
                {/* {this.validator.message('Secondary Status', formFields.sec_status, 'required')} */}
              </div>
            </div>
            {formFields.remark_setting ? (
              <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 mb-3 ">
                <label className="text-left text-black common-label-text ">
                  New Remark
                </label>

                <div className="input-group">
                  <NormalTextarea
                    value={formFields.edit_remark}
                    name="edit_remark"
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            ) : null}

            <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 mb-3">
              <label className="text-left text-black common-label-text ">
                {t("Permanent Remark")}
              </label>

              <div className="input-group">
                <NormalTextarea
                  value={formFields.cust_remark}
                  name="cust_remark"
                  onChange={() => {}}
                  disabled
                />
              </div>
            </div>
            <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-3">
              <label className="text-left text-black common-label-text ">
                {t("Phone")}
              </label>

              <div className="input-group">
                <NormalInput
                  value={formFields.custPhone}
                  name="custPhone"
                  onChange={() => {}}
                  disabled
                />
              </div>
            </div>

            {appointmentId &&
            String(formFields.bookingStatus).toUpperCase() === "ARRIVED" ? (
              <div className="col-md-1 col-12 mb-3">
                <label className="text-left text-black common-label-text ">
                  {t("Cart")}
                </label>
                <div className="input-group">
                  <NormalCheckbox
                    onChange={this.handleChange}
                    value={formFields.cart_create}
                    name="cart_create"
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            {visible ? (
              <div className="customerSearch-block">
                <div className="d-flex mt-3 table table-header w-100 m-0">
                  <div className="col-2">{t("Name")}</div>
                  <div className="col-2">{t("Phone")}</div>
                  <div className="col-2">{t("Customer Code")}</div>
                  <div className="col-2">{t("Reference")}</div>
                  <div className="col-3">{t("Email")}</div>
                  <div className="col-1 d-none">{t("NRIC")}</div>
                </div>
                <div className="response-table w-100 row">
                  {customerOption.length > 0 ? (
                    customerOption.map((item, index) => {
                      return (
                        <div
                          className="row m-0 table-body w-100 border"
                          onClick={() => this.handleSelectCustomer(item)}
                          key={index}
                        >
                          <div className="col-2">{item.cust_name}</div>
                          <div className="col-2">{item.cust_phone2}</div>
                          <div className="col-2">{item.cust_code}</div>
                          <div className="col-2">{item.cust_refer}</div>
                          <div className="col-3">{item.cust_email}</div>
                          <div className="col-1 d-none">{item.cust_nric}</div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="text-center w-100">
                      {t("No Data Available")}
                    </div>
                  )}
                </div>
              </div>
            ) : null}

            {/* Yoonus hide cust refer for apple. others open up*/}
            {
              <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-2 mb-3">
                <label className="text-left text-black common-label-text ">
                  {t("Reference")}
                </label>

                <div className="input-group">
                  <NormalInput
                    value={formFields.cust_refer}
                    name="cust_refer"
                    onChange={() => {}}
                    disabled
                  />
                </div>
              </div>
            }

            {appointmentId && appointmentId > 0 ? (
              <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-3">
                <label className="text-left text-black common-label-text ">
                  {t("Booked By")}
                </label>
                <div className="input-group">
                  <NormalSelect
                    options={optionsUserList}
                    value={formFields.bookedby}
                    name="bookedby"
                    onChange={this.handleChange}
                    className="customer-name py-1"
                    disabled
                  />
                </div>
              </div>
            ) : (
              <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-3">
                <label className="text-left text-black common-label-text ">
                  {t("Booked By")}
                </label>
                <div className="input-group">
                  <NormalSelect
                    options={optionsUserList}
                    value={formFields.bookedby}
                    name="bookedby"
                    onChange={this.handleChange}
                    className="customer-name py-1"
                  />
                </div>
              </div>
            )}

            {/* Yoonus show cust storecard for apple. others hide*/}
            {/* <div className="col-md-3 col-12 ">
              <label className="text-left text-black common-label-text mr-4">
                {t("Customer Store Card")}
              </label>
              <NormalCheckbox
                onChange={this.handleChange}
                value={formFields.cust_StoreCard}
                name="cust_StoreCard"
                checked={formFields.cust_StoreCard}
              />
            </div>
            */}

            {!appointmentId ? (
              <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-2 mb-3">
                <label className="text-left text-black common-label-text ">
                  {t("New Customer")}
                </label>
                <div className="input-group">
                  <NormalCheckbox
                    onChange={this.handleChange}
                    value={isWalkin}
                    name="isWalkin"
                    checked={this.state.isWalkin}
                  />
                </div>
              </div>
            ) : (
              ""
            )}

            {this.state.isWalkin ? (
              <>
                <AddWalkinCustomer
                  site_codeId={formFields.ItemSite_Codeid}
                  handleWalkInCustomer={this.handleWalkInCustomer}
                />
              </>
            ) : (
              ""
            )}
            {appointmentId && appointmentId > 0 ? (
              <div className="col-md-2 col-12 mb-3">
                <label className="text-left text-black common-label-text ">
                  {t("Edited By")}
                </label>
                <div className="input-group">
                  <NormalSelect
                    options={optionsUserList}
                    value={formFields.editedby}
                    name="editedby"
                    onChange={this.handleChange}
                    className="customer-name py-1"
                  />
                </div>
              </div>
            ) : null}
            {this.props.tokenDetail?.customercheckin && (
              <>
                {appointmentId && appointmentId > 0 ? (
                  <div className="col-md-1 col-12 mb-3"></div>
                ) : null}
                {appointmentId && appointmentId > 0 ? (
                  <div className="col-md-3 col-12 mb-3">
                    <label className="text-left text-black common-label-text ">
                      {t("Check in Time")}
                    </label>
                    <div className="input-group">
                      <NormalTimePicker
                        className={`cursor-pointer`}
                        onChange={this.handleTimePick}
                        label="checkinTime"
                        name="checkinTime"
                        timeOnly={true}
                        dateFormat="hh:mm aa"
                        showTime={true}
                        selected={false}
                        placeholder=""
                        //timeIntervals={5}
                        value={checkinTime}
                        showIcon={true}
                      />
                    </div>
                  </div>
                ) : null}
                {appointmentId && appointmentId > 0 ? (
                  <div className="col-md-3 col-12 mb-3">
                    <label className="text-left text-black common-label-text ">
                      {t("Check out Time")}
                    </label>
                    <div className="input-group">
                      <NormalTimePicker
                        className={`cursor-pointer`}
                        onChange={this.handleCheckoutTime}
                        label="checkoutTime"
                        name="checkoutTime"
                        timeOnly={true}
                        dateFormat="hh:mm aa"
                        showTime={true}
                        selected={false}
                        placeholder=""
                        //timeIntervals={5}
                        value={checkoutTime}
                        showIcon={true}
                      />
                    </div>
                  </div>
                ) : null}
                {appointmentId && appointmentId > 0 ? (
                  <div className="mt-4 ml-3">
                    <NormalButton
                      buttonClass={`p-2`}
                      mainbg={true}
                      className="col-12"
                      label="Save"
                      onClick={this.postCheckinTime}
                    />
                  </div>
                ) : null}
              </>
            )}

            {/* Yoonus Class 

            <div className="col-md-1 col-12 mb-3">
              <div className="input-group">
                <label className="text-left text-black common-label-text mr-4">
                  {t("Class")}
                </label>
                {appointmentId == null && (
                  <NormalCheckbox
                    onChange={this.handleChange}
                    value={formFields.chkMaxClass}
                    name="chkMaxClass"
                    checked={formFields.chkMaxClass}
                  />)}
                <NormalInput
                  type="number"
                  value={formFields.maxclasssize}
                  name="maxclasssize"
                  onChange={this.handleChange}
                  disabled={!formFields.chkMaxClass}
                />
              </div>
            </div>
          
             Yoonus Class disabled={!formFields.chkMaxClass} */}

            {appointmentId && appointmentId > 0 && formFields.maxclasssize > 1 && (
              <div className="col-md-3 col-12 mb-3">
                <NormalButton
                  className="col-12 fs-15 mt-3"
                  label="Participants"
                  outline={true}
                  onClick={() => this.handleParticipantsButtonClick()}
                />
              </div>
            )}
          </div>

          {isAppointmentLogModal ? (
            <AppointmentLog
              isAppointmentLogModal={isAppointmentLogModal}
              handleLogClick={this.handleLogClick}
              appointmentId={appointmentId}
            />
          ) : null}

          <NormalModal
            className={"transaction-done-modal"}
            style={{ minWidth: "75%" }}
            modal={isOpenParticipants}
            handleModal={this.handleParticipantsDialog}
          >
            <div className="d-flex justify-content-between">
              <div className="heading">
                <h5> Participants </h5>
              </div>

              <div>
                <img
                  onClick={() => this.setState({ isOpenParticipants: false })}
                  className="close"
                  src={closeIcon}
                  alt=""
                />
              </div>
            </div>
            <div className="content">
              <div className="col-md-4 mb-3">
                <NormalInput
                  placeholder="Participants Search"
                  value={formFields.participantName}
                  name="participantName"
                  onChange={this.handleParticipantSearchFromTextBox}
                  //onClick={this.handleParticipantClick}
                />
              </div>
              {!participantVisible && (
                <table className="col-md-12 mb-3 table">
                  <tr>
                    <th>Date</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Status</th>
                    <th>Remarks</th>
                    <th colSpan="2">Actions</th>
                  </tr>
                  {selectedParticipantsFromAppointments.length > 0 ? (
                    selectedParticipantsFromAppointments.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item.date_booked}</td>
                          <td>{item.cust_name}</td>
                          <td>{item.cust_phone2}</td>
                          <td>{item.status}</td>
                          <td>{item.remarks}</td>
                          <td>
                            <button
                              onClick={this.editParticipantById.bind(
                                this,
                                item
                              )}
                            >
                              Edit
                            </button>
                          </td>
                          <td>
                            <button
                              onClick={this.deleteParticipantById.bind(
                                this,
                                item.id
                              )}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <div className="text-center w-100">
                      {t("No Data Available")}
                    </div>
                  )}
                </table>
              )}
              {participantVisible ? (
                <div className="customerSearch-block">
                  <div className="d-flex mt-3 table table-header w-100 m-0">
                    <div className="col-2">{t("Name")}</div>
                    <div className="col-2">{t("Phone")}</div>
                    <div className="col-2">{t("Customer Code")}</div>
                    <div className="col-2">{t("Reference")}</div>
                    <div className="col-3">{t("Email")}</div>
                    <div className="col-1 d-none">{t("NRIC")}</div>
                  </div>
                  <div className="response-table w-100 row">
                    {participantsData.length > 0 ? (
                      participantsData.map((item, index) => {
                        return (
                          <div
                            className="row m-0 table-body w-100 border"
                            onClick={() => this.handleSelectParticipant(item)}
                            key={index}
                          >
                            <div className="col-2">{item.cust_name}</div>
                            <div className="col-2">{item.cust_phone1}</div>
                            <div className="col-2">{item.cust_code}</div>
                            <div className="col-2">{item.cust_refer}</div>
                            <div className="col-3">{item.cust_email}</div>
                            <div className="col-1 d-none">{item.cust_nric}</div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center w-100">
                        {t("No Data Available")}
                      </div>
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          </NormalModal>
          <NormalModal
            className={"transaction-done-modal"}
            style={{ minWidth: "15%" }}
            modal={this.state.editParticipantPopUp}
            handleModal={this.handleDialog}
          >
            <div className="d-flex justify-content-between">
              <div className="heading">
                <h5> Edit Participant</h5>
              </div>{" "}
              <div>
                <img
                  onClick={() => this.setState({ editParticipantPopUp: false })}
                  className="close"
                  src={closeIcon}
                  alt=""
                />
              </div>
            </div>
            <hr />
            <div>
              <div className="d-flex mt-2">
                <div className="col-4">
                  <Label>Status</Label>
                </div>
                <div className="col-8">
                  <NormalSelect
                    isPlaceholderNeed={false}
                    options={formFields.editParticipantStatusList}
                    value={formFields.editParticipantStatus}
                    name="editParticipantStatus"
                    onChange={this.handleChange}
                    className="customer-name py-1"
                  />
                </div>
              </div>
              <br />
              <div className="d-flex mt-2">
                <div className="col-4">
                  <Label>Remarks</Label>
                </div>
                <div className="col-8">
                  <NormalInput
                    value={formFields.editParticipantRemarks}
                    name="editParticipantRemarks"
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div className="d-flex mt-4">
                <div className="col-6"></div>
                <div className="col-6">
                  <NormalButton
                    applybg={true}
                    label="Update"
                    onClick={() => this.handleParticipantUpdate()}
                  />
                </div>
              </div>
            </div>
          </NormalModal>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  customerDetail: state.appointment.customerDetail,
  customerList: state.common.customerList,
  // Added by Santhosh
  siteId: state.appointment.getSiteId,
  multipleCustomerForm: state.appointment.multipleCustomerForm,
  basicApptDetail: state.appointment.basicApptDetail,
  appointmentCustomerDetail: state.appointment.appointmentCustomerDetail,
  tokenDetail: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      CreateAppointment,
      updateForm,
      getCustomer,
      getCommonApi,
      commonCreateApi,
      commonPatchApi,
      commonDeleteApi,
    },
    dispatch
  );
};

export const AppointmentForm = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(AppointmentFormClass)
);